import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JobTypeEnum } from 'server/shared/models/jobTypeEnum';
import { Shift } from 'server/shared/models/shift';
import { EditShiftsDialog } from '../../jobs/job-edit/dialogs/edit-shifts-dialog/edit-shifts-dialog.component';

@Component({
  selector: 'app-editable-shift-tags',
  templateUrl: './editable-shift-tags.component.html',
  styleUrls: ['./editable-shift-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditableShiftTagsComponent {
  @Input() shifts: Shift[] = [];
  @Input() jobType?: JobTypeEnum;
  @Output() shiftsModified = new EventEmitter<{
    shifts: Shift[];
    jobType?: JobTypeEnum;
  }>();
  @Input() availableShifts: Shift[] = [];
  @Input() isDisabled = false;

  constructor(private ngZone: NgZone, private dialog: MatDialog) {}

  openEditDialog() {
    const modifiedAvailableShifts = this.availableShifts.map(
      (availableShift) =>
        this.shifts.find((dayShift) => dayShift.id === availableShift.id) ||
        availableShift,
    );
    const dialogRef = this.dialog.open(EditShiftsDialog, {
      data: {
        availableShifts: modifiedAvailableShifts,
        selectedShifts: this.shifts,
        showMultiDayToggle: true,
        splitShiftsEnabled: this.shifts.length > 1,
        disabled: this.isDisabled,
        jobType: this.jobType,
        canEditShifts: true,
      },
    });
    dialogRef
      .afterClosed()
      .subscribe(
        (result: { shifts: Shift[]; jobType?: JobTypeEnum } | false) => {
          if (!result) {
            return;
          }
          const shiftsChanged =
            JSON.stringify(this.shifts) !== JSON.stringify(result.shifts);
          const jobTypeChanged = this.jobType !== result.jobType;

          if (!shiftsChanged && !jobTypeChanged) {
            return;
          }
          this.shiftsModified.emit(result);
        },
      );
  }
  jobTypeEnum = JobTypeEnum;
}
